export enum Pages {
  ARTBOARD = 'ARTBOARD',
}

export const paths = {
  [Pages.ARTBOARD]: '/',
};
